export default {

  getLoginInfo: function () {
    return JSON.parse(localStorage.getItem("loginInfo"));
  },

  setLoginInfo: function (loginInfo) {
    localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
  },

  removeLoginInfo: function () {
    return localStorage.removeItem("loginInfo")
  }

}


// WEBPACK FOOTER //
// ./src/services/LoginInfoService.js